import { http } from "../../utils/config";

/**
 * Cấu hình tin gửi vào nhóm Zalo (GMF): nội dung + mã nhóm + brandname theo sự kiện.
 *
 * Hàm async thuần (không `createAsyncThunk`/slice) theo hạ tầng mới `useAsync`/`useAction`:
 * nhận `signal` để hủy được request cũ, và KHÔNG nuốt lỗi — để lỗi axios bay lên cho
 * `errorMessage(e)` bóc câu lỗi thật của BE.
 */

const BASE = "/api/v1/serviceconnect/zalo-group-messages";

export const getZaloGroupMessages = async (signal) => {
  const response = await http.get(BASE, { signal });
  return response.data;
};

/** Danh mục sự kiện hệ thống đang bắn tin — dùng cho ô chọn khi thêm cấu hình. */
export const getSupportedGroupEvents = async (signal) => {
  const response = await http.get(`${BASE}/supported-events`, { signal });
  return response.data;
};

export const createZaloGroupMessage = async (payload) => {
  const response = await http.post(BASE, payload);
  return response.data;
};

/** BE không cho đổi `code`/`branch_id` (khóa xác định dòng) nên payload chỉ gồm phần sửa được. */
export const updateZaloGroupMessage = async ({ id, ...payload }) => {
  const response = await http.put(`${BASE}/${id}`, payload);
  return response.data;
};

export const deleteZaloGroupMessage = async (id) => {
  const response = await http.delete(`${BASE}/${id}`);
  return response.data;
};
